export default __webpack_public_path__ + "static/PaymentSection_uk-4969cc749fed7c826999f0370ea2de11.png";